// Config
import { ADMIN_PATH } from '~/config';

export const useIsAdminPath = () => {
  const isAdminPath = (path: string): boolean => path.includes(ADMIN_PATH);

  return { isAdminPath };
};
